import React, { ReactNode } from "react";
import { SerializedStyles, css } from '@emotion/react';

import { mediaQueries, pxToRem } from "../utils/css-utils";

type GridContainerProps = {
  children: ReactNode,
  rowGap?: Boolean,
  css?: SerializedStyles
};

const GridContainer : React.FC<GridContainerProps> = ({ children, rowGap, ...props }) => {
  const containerStyles = css`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    column-gap: ${pxToRem(20)};
    row-gap: ${rowGap ? pxToRem(24) : '0'};
    width: calc(100% - ${pxToRem(40)});
    margin-left: auto;
    margin-right: auto;

    ${mediaQueries.lg} {
      width: calc(100% - ${pxToRem(80)});
      max-width: ${pxToRem(1600)};
      column-gap: ${pxToRem(40)};
    }

    ${mediaQueries.xxl} {
      width: calc(100% - ${pxToRem(160)});
      max-width: ${pxToRem(1520)};
    }
  `;
  
  return (
    <div {...props} css={containerStyles} >
      { children }
    </div>
  );
};

export default GridContainer;